import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/guards/auth';
import SetupModernLayout from 'src/layouts/setup/modern-compact';
import SetupBillingPage from 'src/pages/setup/setup-billing-page';

import { SplashScreen } from 'src/components/loading-screen';


// ----------------------------------------------------------------------

// JWT
const VerifyEmailPage = lazy(() => import('src/pages/auth/verify-email-page'));

const RegisterOrgInviteView = lazy(
  () => import('src/sections/auth/company-invites/company-invites-view')
);

const CandidateProfileView = lazy(
  () => import('src/sections/auth/candidate-profile/candidate-profile-view')
);

const RegisterJobInviteView = lazy(
  () => import('src/sections/auth/job-invites/register-invites-view')
);

// ----------------------------------------------------------------------

const children = [
  {
    element: (
      <SetupModernLayout>
        <Outlet />
      </SetupModernLayout>
    ),
    children: [
      {
        path: 'organisation/billing/choose-plan',
        element: (
          <AuthGuard>
            <SetupBillingPage />
          </AuthGuard>
        ),
      },
      {
        path: 'organisation/invites',
        element: (
          <AuthGuard>
            <RegisterOrgInviteView />
          </AuthGuard>
        ),
      },

      {
        path: 'candidate/profile',
        element: (
          <AuthGuard>
            <CandidateProfileView />
          </AuthGuard>
        ),
      },
      {
        path: 'candidate/invites',
        element: (
          <AuthGuard>
            <RegisterJobInviteView />
          </AuthGuard>
        ),
      },
    ],
  }
];

export const setupRoutes = [
  {
    path: 'onboarding',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children,
  },
];
